import { Button, TextField } from '@mui/material'
import React, { useEffect, useRef, useState } from 'react'
import { getMetaDataConfig, getNewConfiguration, postConfiguration, updateConfiguration, validateMetaDataResponse } from '../../services/uiConfigService'
import { configurationAttributeType } from '../../types'
import './FirebaseConfig.css'
import { firebaseConfigResgistry } from './firebaseConfigRegistry'
import { androidConfig, firbaseConfigResgistryTypes, iosConfig, webConfig } from './types'
import { configObj, metaDataBatchPayload, popupType } from '../../types/types';
import { GenericPopUp } from '../../components/popup/genericPopUp'
import store from '../../stateManagement/store'
import * as Sentry from "@sentry/react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import RenderSvg from '../../components/renderSvg/RenderSvg'
import { uploadDocument } from '../../services/bankingService'
import { TranslationEnum, usePortalTranslation } from '../../providers/TranslationProvider'
import { META_DATA_BATCH_API } from '../../services/networkService'
import { validateWithOtp } from '../../stateManagement/actions/validateOtpPopupActions'
import { getLob } from '../../services/authenticationService'



function FirebaseConfig() {
    const { translate } = usePortalTranslation();
    const CUR_COMPONENT = "Firebase Configuration"
    const CUR_COMPONENT_COMMON="commonPortal";
    const [webValues, setWebValues] = useState<webConfig>(firebaseConfigResgistry.webFirebaseConfig);
    // const [iosValues, setIosValues] = useState<iosConfig>(firebaseConfigResgistry.iosFirebaseConfig);
    const [iosValues, setIosValues] = useState<string>("");
    // const [androidValues, setAndroidValues] = useState<androidConfig>(firebaseConfigResgistry.androidFirebaseConfig);
    const [androidValues, setAndroidValues] = useState<string>("");
    const [firebaseConfig, setFirebaseConfig] = useState<configurationAttributeType[]>([]);

    const [popupType, setPopupType] = useState<popupType>("Alert");
    const [genericMessage, setGenericMessage] = useState("");
    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [iosFile, setIosFile] = useState<{ [key: string]: string }>({ name: '', blobKey: '' })
    const [androidFile, setAndroidFile] = useState<{ [key: string]: string }>({ name: '', blobKey: '' })
    const authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
    // const [uploadColor, setUploadColor] = useState('#FFFFFF')
    const inputE1 = useRef<HTMLInputElement>(null);
    const inputE2 = useRef<HTMLInputElement>(null);
    const onAndroidClick = () => {
        if (inputE1.current) {
            inputE1.current.click();
        }
    };
    const onIosClick = () => {
        if (inputE2.current) {
            inputE2.current.click();
        }
    };
    // let PUTrequest=true;
    const openPopup = (message: string, type: popupType) => {
        setPopupType(type)
        setGenericMessage(message)
        setOpenGenericModal(true)
    }

    const openFirebase = () => {
        const url = "https://console.firebase.google.com/u/0/";
        window.open(url);
    }

    const handleWebInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setWebValues({
            ...webValues,
            [e.target.name]: e.target.value.trim()
        })
    }
    // const handleAndroidInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setAndroidValues({
    //         ...androidValues,
    //         [e.target.name]: e.target.value.trim()
    //     })
    // }

    // const handleIosInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    //     setIosValues({
    //         ...iosValues,
    //         [e.target.name]: e.target.value.trim()
    //     })
    // }

    const getFirebaseConfig = async () => {
        try {
            const resp = await getNewConfiguration('firebase_config');
            if (resp?.domainValues.length != 0) {
                const previousFirebaseConfig: configurationAttributeType[] = resp?.domainValues;

                setFirebaseConfig([...previousFirebaseConfig]);
                previousFirebaseConfig.map((config: configurationAttributeType) => {
                    switch (config.name) {
                        case 'webFirebaseConfig': {
                            config.value != null ? setWebValues(config.value) : setWebValues(firebaseConfigResgistry.webFirebaseConfig);
                            break;
                        }
                        case 'androidFirebaseConfig': {
                            config.value != null ? setAndroidValues(config.value) : setAndroidValues('');
                            // config.value != null ? setAndroidValues(config.value) : setAndroidValues(firebaseConfigResgistry.androidFirebaseConfig);
                            break;
                        }
                        case 'iosFirebaseConfig': {
                            config.value != null ? setIosValues(config.value) : setIosValues('');
                            // config.value != null ? setIosValues(config.value) : setIosValues(firebaseConfigResgistry.iosFirebaseConfig);
                            break;
                        }

                    }
                })
            }
        } catch (err) {
            // Sentry.captureException(err);
        }
    }

    //fetches current configurations and set it to input fields on first render
    useEffect(() => {
        getFirebaseConfig();
    }, [])


    //convert the configurations to standard config type
    const convertValues = (givenValues: { [key: string]: any }, mainConfig: configurationAttributeType[]): configurationAttributeType[] => {
        const result: configurationAttributeType[] = [];
        Object.keys(givenValues).forEach((val: string) => {
            const givenValInMainConfig = mainConfig.find(config => config.name === val);

            if (!givenValues[val] || givenValues[val] === "") {
                if (givenValInMainConfig) {
                    result.push(givenValInMainConfig)
                }
            } else {
                if (!givenValInMainConfig) {
                    let tempAttribute: configurationAttributeType = {
                        "name": val,
                        "type": "object",
                        "value": givenValues[val],
                        "docUrl": "https://applicate.atlassian.net/l/cp/90s18da0",
                        "description": "firebase config",
                        "possibleVals": [],
                    };
                    result.push(tempAttribute);
                } else {
                    result.push({ ...givenValInMainConfig, value: givenValues[val] });
                }
            }
        });
        return result;
    }

    //returns true if all or none of fields are filled
    const validate = (configValue: object): boolean => {
        let allFilled: boolean = true;
        let allEmpty: boolean = true;
        Object.values(configValue).forEach((value) => {
            if (value.trim() == '') {
                allFilled = false
            } else {
                allEmpty = false
            }
        });
        return (allFilled || allEmpty);
    }

    const generateBlobKey = async (fileUploaded: File) => {
        const formData = new FormData();
        // setIsLoading(true);
        formData.append("files", fileUploaded, fileUploaded.name);
        const fileUploadResponse = await uploadDocument(formData);
        const blobKey: string = JSON.parse(fileUploadResponse[0].body).features[0].Uri;
        return blobKey;
    }

    const handleIosFileInput = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const fileUploaded = event.target.files?.[0];
        if (fileUploaded) {
            const blobKey = await generateBlobKey(fileUploaded);
            setIosFile({ name: fileUploaded.name, blobKey: blobKey });
        }
        // setIsLoading(false);
    }

    const handleAndroidFileInput = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const fileUploaded = event.target.files?.[0];
        if (fileUploaded) {
            const blobKey = await generateBlobKey(fileUploaded);
            setAndroidFile({ name: fileUploaded.name, blobKey: blobKey });
        }
        // setIsLoading(false);
    }

    const saveConfiguration = async (preview?: boolean) => {
        try {
            // if (validate(webValues) && validate(androidValues) && validate(iosValues)) {
            if (validate(webValues)) {
                const configName = 'firebase_config';
                // const resultantValues = { webFirebaseConfig: webValues, androidFirebaseConfig: androidValues, iosFirebaseConfig: iosValues }
                const resultantValues = { webFirebaseConfig: webValues, androidFirebaseConfig: androidFile.blobKey, iosFirebaseConfig: iosFile.blobKey }
                const convertedVals = convertValues(resultantValues, firebaseConfig);

                // let clientConfig = await getMetaDataConfig("clientconfig");
                // if (clientConfig.find((config: { domainType: string }) => config.domainType === configName)) {
                //     await updateConfiguration(configName, convertedVals)
                // } else {
                //     await postConfiguration(configName, convertedVals)
                // }
                const firebaseDataPayload = {
                    domainName: "clientconfig",
                    domainType: "firebase_config",
                    domainValues: convertedVals,
                    lob: getLob(),
                }
                const finalMetaDataPayload: metaDataBatchPayload = { features: [firebaseDataPayload] };
                validateWithOtp((verifiedUser?: any,verifyResponse?: any) => {
                    if (verifyResponse.status >= 200 && verifyResponse.status < 300) {
                        const validationObj = validateMetaDataResponse(verifyResponse?.data?.features);
                        if (validationObj.success) {
                            const androidFileValueInConfig = convertedVals.find((item) => item.name === "androidFirebaseConfig");
                            const iosFileValueInConfig = convertedVals.find((item) => item.name === "iosFirebaseConfig");
            
                            if (androidFileValueInConfig) {
                                setAndroidValues(androidFileValueInConfig?.value ?? "");
                            }
                            if (iosFileValueInConfig) {
                                setIosValues(iosFileValueInConfig?.value ?? "");
                            }
                            openPopup("Configuration Updated", 'Success')
                        } else {
                           openPopup("Something went wrong", "Error");
                        }
                    } else {
                        openPopup("Something went wrong", "Error");
                    }
                  },undefined,"all",META_DATA_BATCH_API,finalMetaDataPayload,"PUT")
            } else {
                openPopup('Please fill complete details', 'Error');
            }
        } catch (err) {
            // Sentry.captureException(err);
            console.error("err===", err)
            //what popup should come on exception?

            // if (err instanceof Error)
            //     openPopup("Validation Error occured : " + err?.message, 'Error')
        }


    }

    return (
        <div className='firebase_container'>

            <div className="main_form_header"> 
                <span className="firebase_main_heading">{translate(TranslationEnum.firebase_configuration,"Firebase Configuration")}</span>
                <span>
                    <Button variant='contained' className='order_button' onClick={openFirebase}>{translate(TranslationEnum.firebase_configuration,"FIREBASE")} &nbsp;<FontAwesomeIcon icon={faUpRightFromSquare} /></Button>
                    <Button variant='contained' className='order_button' onClick={() => { saveConfiguration() }}> {translate(TranslationEnum.common_portal,"SAVE")}</Button>
                </span>
            </div>



            <div className='firebase_config_container'>
                <div className='firebase_config_card'>
                    <h4>
                    {translate(TranslationEnum.firebase_configuration,"FIREBASE FOR WEB")}
                    </h4>
                    {Object.keys(firebaseConfigResgistry.webFirebaseConfig).map((label) => {
                        return <TextField name={label} size='small' label={`${translate(TranslationEnum.firebase_configuration,label)}*`} variant="outlined" value={webValues[label as keyof webConfig]} onChange={handleWebInputChange} />//
                    })}
                </div>

                <div className='firebase_config_card'>
                    <h4>
                    {translate(TranslationEnum.firebase_configuration,"FIREBASE FOR ANDROID")}
                    </h4>
                    <div className="upload-box" >
                        <div className='firebase_upload'>
                            <input type="file" ref={inputE1} hidden
                                onChange={handleAndroidFileInput}
                            />
                            <div className='import_firebase_icon' onClick={onAndroidClick}>
                                <RenderSvg name='UploadImportButton' />
                            </div>
                            {translate(TranslationEnum.common_portal,"Upload")}

                            <div className="firebase_filename">
                                <p>
                                    {androidFile.name}
                                </p>
                            </div>
                            <div className={androidValues ? "" : "firebase_download_disable"}>
                                <a className='import_firebase_icon' href={androidValues} target="_blank">
                                    <RenderSvg name='DownloadImportButton' />
                                </a>
                                {translate(TranslationEnum.common_portal,"Download")}
                            </div>

                            {/* Upload  */}
                        </div>

                    </div>
                    {/* {Object.keys(firebaseConfigResgistry.androidFirebaseConfig).map((label) => {
                        return <TextField name={label} size='small' label={`${label}*`} variant="outlined" value={androidValues[label as keyof androidConfig]} onChange={handleAndroidInputChange} />//
                    })} */}
                </div>

                <div className='firebase_config_card'>
                    <h4>
                    {translate(TranslationEnum.firebase_configuration," FIREBASE FOR IO")}
                    </h4>
                    <div className="upload-box" >
                        <div className='firebase_upload'>

                            <input type="file" ref={inputE2} hidden
                                onChange={handleIosFileInput}
                            />
                            <div className='import_firebase_icon' onClick={onIosClick}>
                                <RenderSvg name='UploadImportButton' />
                            </div>
                            {translate(TranslationEnum.common_portal,"Upload")}

                            <div className="firebase_filename">
                                {iosFile.name}
                            </div>

                            <div className={iosValues ? "" : "firebase_download_disable"}>
                                <a className='import_firebase_icon' href={iosValues} target="_blank" >
                                    <RenderSvg name='DownloadImportButton' />
                                </a>
                                {translate(TranslationEnum.common_portal,"Download")}
                            </div>
                            {/* Upload  */}

                        </div>

                    </div>


                    {/* {Object.keys(firebaseConfigResgistry.iosFirebaseConfig).map((label) => {
                        return <TextField name={label} size='small' label={`${label}*`} variant="outlined" value={iosValues[label as keyof iosConfig]} onChange={handleIosInputChange} />//
                    })} */}
                </div>
            </div>
            <GenericPopUp message={genericMessage}
                type={popupType}
                openGenericModal={openGenericModal}
                setOpenGenericModal={setOpenGenericModal} />
        </div>
    )
}

export default FirebaseConfig